module.exports = __webpack_public_path__ + "img/2.9ebefb22.png";